import * as React from "react";
import { ReviewSnippet } from "@grandvisionhq/reviews";
import { getReviewsConfigKeys } from "../../utils/modules/Reviews/utils/get-reviews-config-keys.js";
import { useProductData } from "../../../../context/context/product-context-hooks.js";
const StarRatingReview = ({ className }) => {
  const {
    product,
    activeVariant: { sku }
  } = useProductData();
  const { productId, variantId } = getReviewsConfigKeys(product, sku);
  return /* @__PURE__ */ React.createElement(ReviewSnippet, { className, productId, variantId });
};
export {
  StarRatingReview
};
//# sourceMappingURL=StarRatingReview.js.map
